import { Injectable } from '@angular/core';
///Use this class to define common variables to be accessed across components
@Injectable()
export class AppGlobals {
    rendredOnLogin:boolean=true;
    // global_organizationId:string="";
    // global_groupId:string="";
}